import { AxiosResponse } from "axios";
import { FormularioInformeDividendoRecaudadoModel } from "../models/formularioInformeDividendoRecaudadoModel";
import { FormularioInformeDividendoNoRecaudadoModel } from "../models/formularioInformeDividendoNoRecaudadoModel";
import { FileEndosoDto } from "../../../endosos/generacionmasiva/models/fileEndosoDto";
import axiosInstance from "../../../../interceptors/axiosInstance";

const generarReporteDividendoRecaudacion = async (e: FormularioInformeDividendoRecaudadoModel) : Promise<AxiosResponse<FileEndosoDto>> => {
    const response = await axiosInstance.post("siscred-api-reportes/v1/contabilidad/reporte-dividendo-recaudacion", e)
    return response;
}

const generarReporteDividendoNoRecaudacion = async (e: FormularioInformeDividendoNoRecaudadoModel) : Promise<AxiosResponse<FileEndosoDto>> => {
    const response = await axiosInstance.post("siscred-api-reportes/v1/contabilidad/reporte-dividendo-no-recaudado", e)
    return response;
}

export {
    generarReporteDividendoRecaudacion,
    generarReporteDividendoNoRecaudacion
}